module.exports = __webpack_public_path__ + "static/logo14-96335d427a6eb1ac4f376bff17cef2ad.png";